module.exports = __webpack_public_path__ + "img/logo-top.09750ae2.webp";